module.exports = __webpack_public_path__ + "static/media/portfolio6.32a90284.jpg";